export interface CohortStatsType {
  id: string;
  name: string;
  total_users: number;
  cert_halfway_completed: number;
  cert_completed: number;
  matching_completed: number;
  registration_completed: number;
  progress_looked_completed: number;
  progress_oriented_completed: number;
  progress_watch_completed: number;
  attended_events: number; // cert.kickoff or cert.check_in or cert.completion >= 1
  reflection_completed: number; // cert.reflection >= 1
  program_eval_completed: number;
  goals_coach: number;
  goals_coachee: number;
  confirmed_users: number;
  partnered_users: number; // partner array exists and has matching cohort
  openness_pre_stats: {
    [key: string]: {
    "Never": number;
    "Rarely": number;
    "Sometimes": number;
    "Often": number;
    "Very often": number;
    }
  };
  openness_post_stats: {
    [key: string]: {
    "Never": number;
    "Rarely": number;
    "Sometimes": number;
    "Often": number;
    "Very often": number;
    }
  };
}

export const CohortStatsDefaults: CohortStatsType = {
  id: '',
  name: '',
  total_users: 0,
  cert_halfway_completed: 0,
  cert_completed: 0,
  matching_completed: 0,
  registration_completed: 0,
  progress_looked_completed: 0,
  progress_oriented_completed: 0,
  progress_watch_completed: 0,
  attended_events: 0,
  reflection_completed: 0,
  program_eval_completed: 0,
  goals_coach: 0,
  goals_coachee: 0,
  confirmed_users: 0,
  partnered_users: 0,
  openness_pre_stats: {
    "When you have a problem or worry, how often do you let someone in your personal life know about it?": {
      "Never": 0,
      "Rarely": 0,
      "Sometimes": 0,
      "Often": 0,
      "Very often": 0
    },
    "How often are you willing to share your thoughts and feelings even when doing so makes you feel a bit vulnerable?": {
      "Never": 0,
      "Rarely": 0,
      "Sometimes": 0,
      "Often": 0,
      "Very often": 0
    },
    "How often do you stay curious about another person’s thoughts and feelings even if you disagree with them?": {
      "Never": 0,
      "Rarely": 0,
      "Sometimes": 0,
      "Often": 0,
      "Very often": 0
    },
    "How often do you feel useful or helpful when listening attentively to another person?": {
      "Never": 0,
      "Rarely": 0,
      "Sometimes": 0,
      "Often": 0,
      "Very often": 0
    }
  },
  openness_post_stats: {
    "When you have a problem or worry, how often do you let someone in your personal life know about it?": {
      "Never": 0,
      "Rarely": 0,
      "Sometimes": 0,
      "Often": 0,
      "Very often": 0
    },
    "How often are you willing to share your thoughts and feelings even when doing so makes you feel a bit vulnerable?": {
      "Never": 0,
      "Rarely": 0,
      "Sometimes": 0,
      "Often": 0,
      "Very often": 0
    },
    "How often do you stay curious about another person’s thoughts and feelings even if you disagree with them?": {
      "Never": 0,
      "Rarely": 0,
      "Sometimes": 0,
      "Often": 0,
      "Very often": 0
    },
    "How often do you feel useful or helpful when listening attentively to another person?": {
      "Never": 0,
      "Rarely": 0,
      "Sometimes": 0,
      "Often": 0,
      "Very often": 0
    }
  }
};

export type CohortOnboardingData = Pick<CohortType, 
  'start_date' | 
  'evaluation_deadline_date' | 
  'enrollment_deadline_date' | 
  'matching_date' | 
  'payment_amount'
> & {
  current_cohort: string | null;
  matching_deadline_string: string;
};

export const CohortOnboardingDataDefaults: CohortOnboardingData = {
  current_cohort: null,
  start_date: '',
  evaluation_deadline_date: '',
  enrollment_deadline_date: '',
  matching_deadline_string: '',
  matching_date: -1,
  payment_amount: 0
};

export interface CohortType {
  evaluation_deadline_date: string;
  enrollment_deadline_date: string; // for deadlines, converted to setHours(23, 59, 59, 999)
  group: string;
  group_name: string;
  id: string;
  matching_date: number; // timestamp in ms
  name: string;
  max_size: number;
  participants: string[] | null; // array of pax id
  start_date: string; // for deadlines, converted to setHours(0, 0, 0, 0)
  last_modified: string;
  stats: CohortStatsType;
  payment_amount: number;
}

export const CohortTypeDefaults: CohortType = {
  evaluation_deadline_date: '',
  enrollment_deadline_date: '', // for deadlines, converted to setHours(23, 59, 59, 999)
  group: '',
  group_name: '',
  id: '',
  matching_date: -1, // timestamp in ms
  name: 'New Cohort',
  max_size: 150,
  participants: null,
  start_date: '', // for deadlines, converted to setHours(0, 0, 0, 0)
  last_modified: '',
  stats: CohortStatsDefaults,
  payment_amount: 0,
};